// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vzsuikhlndbxrhkmiehr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ6c3Vpa2hsbmRieHJoa21pZWhyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgwOTg2MDIsImV4cCI6MjA1MzY3NDYwMn0.qGmbAlt30s13qN0UhMdUgSgG_EWYSk2MxXVWrHHxKuc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);